import { useQueryClient, useMutation } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import useCloudPermissions from "../../../../hooks/useCloudPermissions";
import { tenantIDAtom } from "../../../../atoms/GlobalAtoms";
import TenantAPI from "../../../api/TenantAPI";
import { newToastEvent } from "../../../../utils/ToastUtil";
import { getErrorMessage } from "../../../../utils/GeneralUtils";

// Used to delete an individual cloud backup.
const useDeleteBackup = () => {
  const { cPermissions } = useCloudPermissions();
  const queryClient = useQueryClient();
  const tenantID = useAtomValue(tenantIDAtom);

  const deleteBackup = useMutation({
    mutationFn: ({ backupID }: { backupID: string }) => {
      // TODO: Add cPermissions scope
      if (false) {
        return Promise.reject("You don't have permission to delete backups.");
      }

      return TenantAPI.deleteBackup(backupID);
    },
    onSuccess: (_, { backupID }) => {
      newToastEvent("success", "Successfully deleted backup.");

      queryClient.invalidateQueries({
        queryKey: ["backupHistory", tenantID],
      });
    },
  });

  return {
    deleteBackup: deleteBackup.mutate,
    deletingBackup: deleteBackup.isPending,
    deleteBackupError: deleteBackup.error
      ? getErrorMessage(deleteBackup.error)
      : null,
  };
};

export default useDeleteBackup;
